module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = 31
// module chunks = 0